import * as React from 'react';
import Button from '../common/form/Button';
let warningIcon = require('../../images/warning.png');

interface State {
    activeIndex: number;
}

export interface LabeledPage {
    tabLabel: string;
    warning?: boolean;
    render: () => JSX.Element;
}

interface Props {
    pages: LabeledPage[];
    additionalRightContent?: JSX.Element;
    additionalTopContent?: JSX.Element;
    onPageChange: () => void;
    activeIndex?: number;
}

class TabbedPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            activeIndex: this.props.activeIndex && this.props.activeIndex > 0 ? this.props.activeIndex : 0,
        };
        console.log('this.props.activeIndex', this.props.activeIndex);
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if(this.props.activeIndex && prevProps.activeIndex !== this.props.activeIndex) {
            this.setState({
                activeIndex: this.props.activeIndex > 0 ? this.props.activeIndex : 0
            })
        }
    }

    render() {
        return this.state.activeIndex > this.props.pages.length - 1 ? (
            <div />
        ) : (
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <div className="btn-group" role="group">
                            {this.props.pages.map((page, index) => (
                                <Button
                                    key={index}
                                    text={page.tabLabel}
                                    addlClassName={
                                        this.state.activeIndex === index
                                            ? 'btn-light'
                                            : 'btn-primary'
                                    }
                                    onClick={() => {
                                        if (this.state.activeIndex !== index) {
                                            this.setState({ activeIndex: index });
                                            this.props.onPageChange();
                                        }
                                    }}
                                >
                                    {page.warning && (
                                        <img className="tab-warning" src={warningIcon} />
                                    )}
                                </Button>
                            ))}
                        </div>
                    </div>
                    {this.props.additionalRightContent && (
                        <div className="d-flex col justify-content-end">
                            {this.props.additionalRightContent}
                        </div>
                    )}
                </div>
                {this.props.additionalTopContent}
                {this.props.pages[this.state.activeIndex].render()}
            </div>
        );
    }
}

export default TabbedPage;



// WEBPACK FOOTER //
// ./src/components/common/TabbedPage.tsx